import { OwaDate, differenceInMinutes } from 'owa-datetime';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { TimeChangeActionType } from 'owa-calendar-helpers-types';

export function getTimeSuggestionsDiffInMinutesFromEvent(
    event: CalendarEvent,
    timeSuggestionsStartSet: OwaDate[]
): number[] {
    return timeSuggestionsStartSet?.map(timeSuggestionStart =>
        differenceInMinutes(timeSuggestionStart, event.Start)
    );
}

export function isTimeSuggestionLastTimeChangeAction() {
    const { metricsInfo } = getComposeStore();
    return (
        metricsInfo.changeTimeActions?.[metricsInfo.changeTimeActions.length - 1] ===
        TimeChangeActionType.TimeSuggestions
    );
}
